// eslint-disable-next-line max-statements
export const nextOccurrenceFromHHmm = (
  time: string,
  now: Date = new Date(),
): Date => {
  const match = /^(\d{2}):(\d{2})$/.exec(time);
  if (!match) throw new Error(`Invalid time format: "${time}". Expected "HH:mm".`);

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (hours > 23 || minutes > 59) throw new Error(`Invalid time: ${time}`);

  const candidate = new Date(now);
  candidate.setHours(hours, minutes, 0, 0);

  if (candidate < now) {
    candidate.setDate(candidate.getDate() + 1);
  }

  return candidate;
};
